import React, { useState } from "react";
import { Card } from "react-bootstrap";
import { FiDownload, FiCalendar } from "react-icons/fi";

export default function HeadcountCard() {
  const [open, setOpen] = useState(false);
  const [quarter, setQuarter] = useState("1st Quarter");

  const quarters = ["1st Quarter", "2nd Quarter", "3rd Quarter", "4th Quarter"];

  const data = [
    { p: 18, h: -10, m: "Jan" },
    { p: 28, h: -25, m: "Jan" },
    { p: 30, h: -22, m: "Jan" },
    { p: 20, h: -18, m: "Jan" },

    { p: 15, h: -20, m: "Feb" },
    { p: 30, h: -22, m: "Feb" },
    { p: 25, h: -15, m: "Feb" },
    { p: 18, h: -28, m: "Feb" },

    { p: 20, h: -18, m: "Mar" },
    { p: 22, h: -22, m: "Mar" },
    { p: 30, h: -30, m: "Mar" },
    { p: 14, h: -12, m: "Mar" },

    { p: 20, h: -10, m: "Apr" },
    { p: 25, h: -28, m: "Apr" },
    { p: 18, h: -12, m: "Apr" },
    { p: 26, h: -24, m: "Apr" },
  ];

  return (
    <Card className="hcg-card h-100">
      <Card.Body>

        {/* HEADER */}
        <div className="hcg-header">
          <h2>Headcount Vs Payroll Growth</h2>

          <div className="hcg-right">
            <div className="hcg-legend">
              <span className="hcg-sq hcg-orange"></span> Payroll Growth
              <span className="hcg-sq hcg-gray"></span> Head Count
            </div>

            <div className="hcg-icon-btn">
              <FiDownload />
            </div>
          </div>
        </div>

        {/* TOP */}
        <div className="hcg-top mt-2">
          <div>
            <h4  className="text-dark" >+14%</h4>
            <p>Increased From the Last Quarter</p>
          </div>

          <div className="hcg-dropdown mt-3">
            <button onClick={() => setOpen(!open)}>
              <FiCalendar /> {quarter}
            </button>

            {open && (
              <div style={{zIndex:"100"}} className="hcg-dropdown-menu">
                {quarters.map((q) => (
                  <div key={q} onClick={() => {
                    setQuarter(q);
                    setOpen(false);
                  }}>
                    {q}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        {/* GRAPH */}
        <div className="hcg-graph mt-2">

          <div className="hcg-grid">
            {[30, 20, 10, 0, -10, -20, -30].map((val) => (
              <div key={val} className="hcg-grid-row">
                <span>{val}K</span>
              </div>
            ))}
          </div>

          <div className="hcg-bars">
            {data.map((item, i) => (
              <div className="hcg-bar-group" key={i}>

                <div className="hcg-bar-wrapper">

                  {/* TOOLTIP */}
                  <div className="hcg-tooltip">
                    <div>{item.m}</div>

                    <div className="hcg-tooltip-row">
                      <span className="hcg-dot-gray"></span>
                      Headcount: <b>{item.h}K</b>
                    </div>

                    <div className="hcg-tooltip-row">
                      <span className="hcg-dot-orange"></span>
                      Payroll: <b>{item.p}K</b>
                    </div>
                  </div>

                  <div
                    className="hcg-bar-top"
                    style={{ height: `${item.p * 3}px` }}
                  />
                </div>

                <div
                  className="hcg-bar-bottom"
                  style={{ height: `${Math.abs(item.h) * 3}px` }}
                />
              </div>
            ))}
          </div>
        </div>

        {/* MONTHS */}
        <div className="hcg-months">
          <span>Jan</span>
          <span>Feb</span>
          <span>Mar</span>
          <span>Apr</span>
        </div>

      </Card.Body>

      {/* CSS */}
      <style>{`

        .hcg-card {
          border-radius:5px;
          border: 2px solid #e5e7eb;
        }

        .hcg-header {
          display:flex;
          justify-content:space-between;
        }

        .hcg-header h2 {
          font-size:18px;
          text-decoration:underline;
        }

        .hcg-right {
          display:flex;
          gap:15px;
          align-items:center;
        }

        .hcg-legend {
          display:flex;
          gap:10px;
          align-items:center;
        }

        .hcg-sq {
          width:10px;
          height:10px;
        }

        .hcg-orange { background:#f26522 }
        .hcg-gray { background:#d1d5db }

        .hcg-icon-btn {
          width:36px;
          height:36px;
          background:#f3f4f6;
          border-radius:50%;
          display:flex;
          align-items:center;
          justify-content:center;
        }

        .hcg-top {
          display:flex;
          justify-content:space-between;
        }

        .hcg-top h3 { color:#f26522 }

        .hcg-dropdown { position:relative }

        .hcg-dropdown button {
          border:1px solid #e5e7eb;
          border-radius:20px;
          padding:6px 12px;
          background:#fff;
        }

        .hcg-dropdown-menu {
          position:absolute;
          top:40px;
          right:0;
          background:#fff;
          padding:10px;
          border-radius:10px;
          box-shadow:0 4px 12px rgba(0,0,0,0.1);
        }

        .hcg-dropdown-menu div {
          padding:8px;
          cursor:pointer;
        }

        .hcg-dropdown-menu div:hover {
          background:#f26522;
          color:#fff;
        }

        .hcg-graph {
          position:relative;
          height:230px;
        }

        .hcg-grid {
          position:absolute;
          inset:0;
          display:flex;
          flex-direction:column;
          justify-content:space-between;
        }

        .hcg-grid-row {
          border-top:1.5px solid #d1d5db;
          position:relative;
        }

        .hcg-grid-row span {
          position:absolute;
          right:0;
          font-size:12px;
        }

        .hcg-bars {
          display:flex;
          justify-content:space-between;
          align-items:center;
          height:100%;
          padding-right:40px;
        }

        .hcg-bar-group {
          display:flex;
          flex-direction:column;
          align-items:center;
          
        }

        .hcg-bar-top,
        .hcg-bar-bottom {
          width:20px;
          border-radius:20px;
        }

        .hcg-bar-top { background:#f26522 }
        .hcg-bar-bottom { background:#d1d5db }

        .hcg-bar-wrapper { position:relative }

        .hcg-tooltip {
          position:absolute;
          bottom:100%;
          left:50%;
          transform:translateX(-50%);
          background:rgba(255,255,255,0.9);
          padding:8px;
          border-radius:8px;
          font-size:12px;
          box-shadow:0 4px 10px rgba(0,0,0,0.1);
          opacity:0;
          transition:0.3s;
          white-space:nowrap;
        }

        .hcg-bar-wrapper:hover .hcg-tooltip {
          opacity:1;
        }

        .hcg-tooltip-row {
          display:flex;
          gap:6px;
          align-items:center;
        }

        .hcg-dot-gray,
        .hcg-dot-orange {
          width:8px;
          height:8px;
          border-radius:50%;
        }

        .hcg-dot-gray { background:#d1d5db }
        .hcg-dot-orange { background:#f26522 }

        .hcg-months {
          display:flex;
          justify-content:space-between;
          margin-top:10px;
          padding-right:40px;
        }

      `}</style>
    </Card>
  );
}